export default "/fonts/trailblazerh-demibold.woff?0139d5133ab775c519b184799eda1a96";